(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var MOBILE_MQ = '(max-width: 749px)';

    function ready(cb) {
      if (typeof window.jQuery === 'undefined' || typeof window.jQuery.fn.slick === 'undefined') {
        return setTimeout(function () {
          ready(cb);
        }, 100);
      }
      cb(window.jQuery);
    }

    ready(function ($) {
      var $list = $('.latest-products__list');
      if (!$list.length) return;

      function initSlider() {
        if ($list.hasClass('slick-initialized')) return;
        $list.slick({
          slidesToShow: 1.2,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          infinite: false,
          autoplay: false,
          responsive: [{ breakpoint: 480, settings: { slidesToShow: 1.1 } }],
        });
      }

      function destroySlider() {
        if ($list.hasClass('slick-initialized')) {
          $list.slick('unslick');
        }
      }

      var mq = window.matchMedia(MOBILE_MQ);
      function handle(e) {
        if (e.matches) initSlider();
        else destroySlider();
      }
      handle(mq);
      if (mq.addEventListener) mq.addEventListener('change', handle);
      else mq.addListener(handle);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  function initHeroSlider() {
    if (typeof window.jQuery === 'undefined' || typeof window.jQuery.fn.slick === 'undefined') {
      return setTimeout(initHeroSlider, 100);
    }
    var arrowLeft = "<svg width='17' height='41' viewBox='0 0 17 41' fill='none' xmlns='http://www.w3.org/2000/svg'><line y1='-1' x2='25.3958' y2='-1' transform='matrix(-0.620753 -0.784006 0.283556 -0.958956 16.3315 39)' stroke='white' stroke-width='2'/><line y1='-1' x2='24.9095' y2='-1' transform='matrix(-0.642325 0.766433 -0.269055 -0.963125 16.3315 1.39877e-06)' stroke='white' stroke-width='2'/></svg>"
    var arrowRight = "<svg width='17' height='41' viewBox='0 0 17 41' fill='none' xmlns='http://www.w3.org/2000/svg'><line y1='-1' x2='25.3958' y2='-1' transform='matrix(0.620753 -0.784006 -0.283556 -0.958956 0.668457 39)' stroke='white' stroke-width='2'/><line y1='-1' x2='24.9095' y2='-1' transform='matrix(0.642325 0.766433 0.269055 -0.963125 0.668457 1.39877e-06)' stroke='white' stroke-width='2'/></svg>"
    window.jQuery('.hero-slider__wrapper').slick({
      autoplay: true,
      autoplaySpeed: 5000,
      arrows: true,
      dots: false,
      fade: true,
      speed: 800,
      slidesToShow: 1,
      slidesToScroll: 1,
      pauseOnHover: false,
      adaptiveHeight: false,
      prevArrow: `<button type="button" class="slick-prev">${arrowLeft}</button>`,
      nextArrow: `<button type="button" class="slick-next">${arrowRight}</button>`,
    });
  }
  initHeroSlider();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["latest-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var MOBILE_MQ = '(max-width: 749px)';

    function ready(cb) {
      if (typeof window.jQuery === 'undefined' || typeof window.jQuery.fn.slick === 'undefined') {
        return setTimeout(function () { ready(cb); }, 100);
      }
      cb(window.jQuery);
    }

    ready(function ($) {
      var $list = $('.latest-products__list');
      if (!$list.length) return;

      function initSlider() {
        if ($list.hasClass('slick-initialized')) return;
        $list.slick({
          slidesToShow: 1.2,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          infinite: false,
          autoplay: false,
          responsive: [
            { breakpoint: 480, settings: { slidesToShow: 1.1 } }
          ]
        });
      }

      function destroySlider() {
        if ($list.hasClass('slick-initialized')) {
          $list.slick('unslick');
        }
      }

      var mq = window.matchMedia(MOBILE_MQ);
      function handle(e) {
        if (e.matches) initSlider(); else destroySlider();
      }
      handle(mq);
      if (mq.addEventListener) mq.addEventListener('change', handle);
      else mq.addListener(handle);
    });
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stay-connected"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  function initMarquee() {
    if (typeof window.jQuery === 'undefined' || typeof window.jQuery.fn.slick === 'undefined') {
      return setTimeout(initMarquee, 100);
    }
    var $marquee = window.jQuery('.stay-connected__marquee');
    if (!$marquee.length || $marquee.hasClass('slick-initialized')) return;

    $marquee.slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 5000,
      cssEase: 'linear',
      infinite: true,
      arrows: false,
      dots: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      swipe: true,
      variableWidth: false,
      responsive: [
        { breakpoint: 1200, settings: { slidesToShow: 4 } },
        { breakpoint: 990,  settings: { slidesToShow: 3 } },
        { breakpoint: 749,  settings: { slidesToShow: 2 } },
        { breakpoint: 480,  settings: { slidesToShow: 1.5 } }
      ]
    });
  }
  initMarquee();
});

  } catch(e) { console.error(e); }
})();
})();
